import {
  FormPagePropertyItemMultipleSelection,
  FormPageInputItemSelectionSubtext,
} from 'backend';
import {
  FormPageInputData,
  MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE,
} from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';
import { getSelectionPropertyItemSubtextFormCustomizeQuerySelector } from '../getPropertyItemElements/formCustomize/singleSelection';
import { getSelectionPropertyItemSubtextQuerySelector } from '../getPropertyItemElements/singleSelection';

export const getMultipleSelectionInputValue = (
  propertyItem: FormPagePropertyItemMultipleSelection,
  propertyItemElement: PropertyItemElement,
  isFormCustomize: boolean,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE.checkbox:
    case MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE.checkboxHorizontal: {
      const checkboxElements = propertyItemElement.checkboxes;
      const isAllCheckbox =
        Array.isArray(checkboxElements) &&
        checkboxElements.every(
          (element) =>
            element instanceof HTMLInputElement && element.type === 'checkbox',
        );

      if (!isAllCheckbox) {
        return {};
      }
      const checkedValues = (checkboxElements as HTMLInputElement[])
        .filter((element) => element.checked)
        .map((element) => Number(element.value));
      const subtextQuerySelectorFunc = !isFormCustomize
        ? getSelectionPropertyItemSubtextQuerySelector
        : getSelectionPropertyItemSubtextFormCustomizeQuerySelector;
      const subtextValues = propertyItem.candidates
        .filter(
          (candidate) => candidate.subtext != null && candidate.value != null,
        )
        .map((candidate) => {
          const subtextElement = document.querySelector<HTMLInputElement>(
            subtextQuerySelectorFunc(
              propertyItem.propertyId,
              candidate.value ?? 0,
            ),
          );
          return subtextElement
            ? ({
                value: Number(candidate.value),
                subtext: subtextElement.value,
              } as FormPageInputItemSelectionSubtext)
            : null;
        })
        .filter(
          (
            subtextValue,
          ): subtextValue is Exclude<FormPageInputItemSelectionSubtext, null> =>
            subtextValue != null,
        );
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'multipleSelectionCheckbox',
          values: checkedValues,
          subtexts: subtextValues,
        },
      };
    }
  }
};
